import {useContext, useEffect, useState} from "react";
import {DataContext} from "../../contexts/dataContext";
import {translateService} from "../../services/TranslateService";

interface ITabInfo {
    icon: string;
    title: string;
    route: string;
    page?: number;
    disable?: boolean;
}

interface StepsProps {
    next?: () => void;
    back?: (page: number) => void;
    onTabChange?: (newTab: number) => void;
}

export const Steps = ({ onTabChange }: StepsProps) => {
    const defaultPage = sessionStorage.getItem('page') || 0;
    let x = 0;
    if(defaultPage) {
        sessionStorage.setItem('page', defaultPage);
        x = JSON.parse(defaultPage);
    }
    
    const { changePage, changeRoute, route, page = x, reservationCreated, changeSearchParameters, searchParameters, sendGaEvent, authHashLogin } = useContext(DataContext);
    const [TabInfo, setTabInfo] = useState<ITabInfo[]>([]);


    useEffect(() => {
        if (!authHashLogin) {
            setTabInfo([
                {
                    icon: "1",
                    title: translateService.translate("vehicleSearch1.step1"),
                    route: "/",
                    page: 0,
                    disable: false,
                },
                {
                    icon: "2",
                    title: translateService.translate("vehicleSearch1.step2"),
                    route: "/makereservation",
                    page: 1,
                    disable: page < 1 || ( route !== "/makereservation") || reservationCreated,
                },
                {
                    icon: "3",
                    title: translateService.translate("vehicleSearch1.step3"),
                    route: "/makereservation",
                    page: 2,
                    disable: page < 2 || (page === 2 && route !== "/makereservation") || reservationCreated,
                },
                {
                    icon: "4",
                    title: translateService.translate("vehicleSearch1.step4"),
                    route: "/myreservations",
                    page: 3,
                    disable: page < 3 || (page === 3 && route !== "/makereservation"),
                }
            ]);
        } else {
            setTabInfo([
                {
                    icon: "1",
                    title: translateService.translate("vehicleSearch1.step1"),
                    route: "/",
                    page: 0,
                    disable: false,
                },
                {
                    icon: "2",
                    title: translateService.translate("vehicleSearch1.step2"),
                    route: "/makereservation",
                    page: 1,
                    disable: page < 1 || ( route !== "/makereservation") || reservationCreated,
                },
                {
                    icon: "3",
                    title: translateService.translate("vehicleSearch1.step4"),
                    route: "/myreservations",
                    page: 2,
                    disable: page < 2 || (page === 2 && route !== "/makereservation"),
                }
            ]);
        }
    }, [page, route, reservationCreated]);

    const handleTab = (tab: ITabInfo) => {
        if(typeof tab.page == 'number' && tab.page >= 0) {
            changePage(tab.page);
            changeRoute(tab.route);
            if (onTabChange) {
                onTabChange(tab.page);
            }
            if (searchParameters?.carId && tab.page === 0) {
                changeSearchParameters({...searchParameters, carId: null});
                sessionStorage.setItem('carIdChanged', 'true'); // if carId from url param, this disables using url id afterwards
            }

            if(page !== tab.page){
                switch(tab.page) {
                    case 0:
                        sendGaEvent('reservation', 'backToSearchResults', '', 0);
                        break;
                    case 1:
                        sendGaEvent('reservation', 'backToBeginReservation', '', 0);
                        break;
                    case 2:
                        if (!authHashLogin) {
                            sendGaEvent('reservation', 'backToCustomerForm', '', 0);
                        } else {
                            sendGaEvent('reservation', 'backToBeginReservation', '', 0); // auth login does not show customer info
                        }
                        break;
                }
            }
        }
    }

    return (
        <div className={'container-fluid my-2'}>
            <div className="tabs row p-3 bg-white" role="tablist">
                {TabInfo.map((tab: ITabInfo, index: number) => (
                    <div key={index} className={` ${!authHashLogin ? 'col-3' : 'col-4'} px-1  ${tab.disable ? 'bg-white border-0' : ' border-0 '}`}>
                        <button
                            key={index}
                            role="tab"
                            className={`w-100 p-2 d-flex justify-content-center align-items-center flex-column ${tab.page === page ? 'bg-primary border-0 rounded' : 'bg-white rounded border-0'}`}
                            id={`tab-${index}`}
                            aria-selected={page === index}
                            aria-controls={`panel-${index}`}
                            disabled={tab.disable}
                            onClick={() => handleTab(tab)  }
                        >
                            <div className={`${!tab.disable ? 'round-div-active' : 'round-div-inactive'}`}><span className={'custom-icon p-1 rounded-circle'}>{tab.icon}</span></div>
                            <div className={'font-weight-bold text-capitalize pt-1 text-wrap'} style={{fontSize: '11px'}}>{tab.title}</div>
                        </button>
                    </div>


                ))}
            </div>
        </div>
    )
}